module.exports = __webpack_public_path__ + "img/qywh-item-logo3.77cc94ec.png";